module.exports = __webpack_public_path__ + "static/media/GALAD Аврора LED.ac998dac.jpg";